import { render, staticRenderFns } from "./ClienteDadosPioresCrescimento.vue?vue&type=template&id=3c50fc6c&scoped=true&"
import script from "./ClienteDadosPioresCrescimento.vue?vue&type=script&lang=js&"
export * from "./ClienteDadosPioresCrescimento.vue?vue&type=script&lang=js&"
import style0 from "./ClienteDadosPioresCrescimento.vue?vue&type=style&index=0&id=3c50fc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50fc6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
